import type { RouteRecordRaw } from 'vue-router';
export const fieldServiceRoutes: RouteRecordRaw[] = [
  {
    path: 'field-service',
    name: 'field-service',
    component: () => import('../pages/field-service/FieldServicePage.vue'),
    meta: { requiresModule: 'field-service' },
  },
];
